// extracted by mini-css-extract-plugin
export default {"next_order":"ws","recurringdis":"xs","reactivate_button":"ys","order__summary_title":"zs","order__summary_items":"As","order__summary_item":"Bs","order__summary_item_title":"Cs","order__summary_item_quantity":"Es","order__item_separator":"Fs","discount":"Gs","promowrapper":"Hs"};
    if(module.hot) {
      // 1711394576032
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  